import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import SnackBar from "../../../components/SnackBar";
import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import styles from "./styles.module.css";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import { solicitaDocsPrevias } from "../../../services/api-inss.service";

const ModalSolicitaDocs = ({ open, setOpen, idPrevia, product }) => {
  const inicialStateObjectSubmit = {
    documentos: { value: [], error: false },
    observacoes: { value: "", error: false },
  };

  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);
  const [objectSubmit, setObjectSubmit] = useState(inicialStateObjectSubmit);
  const [optionsDocs, setOptionsDocs] = useState([]);

  useEffect(() => {
    const setoOptions = async () => {
      setLoading(true);
      try {
        let codCombo = "";
        switch (product) {
          case "INSS":
            codCombo = "TIPODOCPREVIA-INSS";
            break;
          case "PIS/COFINS":
            codCombo = "TIPODOCPREVIA-PIS/COFINS";
            break;
          case "ICMS":
            codCombo = "TIPODOCPREVIA-ICMS";

          default:
            throw new Error("Tipo de produto não encontrado");
        }

        const responseOptions = await buscarComboPorCodigo(codCombo);

        const optionsList = responseOptions.detalhes.itensCombo.map((item) => {
          const splitValues = item.split("/|/");
          return {
            id: splitValues[0],
            label: splitValues[1],
          };
        });

        setOptionsDocs(optionsList);
      } catch (error) {
        console.error(error);
        setObjSnackBar({ type: "error", msg: "Erro ao buscar documentos" });
      } finally {
        setLoading(false);
      }
    };

    setoOptions();
  }, []);

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleCloseModal = () => {
    setObjectSubmit(inicialStateObjectSubmit);
    setOpen(false);
  };

  const handleChange = (name, value) => {
    setObjectSubmit({
      ...objectSubmit,
      [name]: { value, error: value ? false : true },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const erro = Object.values(objectSubmit).some(
      (item) => item.error === true || item.value === ""
    );

    const solicitacao = {
      documentos: objectSubmit.documentos.value,
      idPrevia,
      observacoes: objectSubmit.observacoes.value,
      servico: product,
    };

    try {
      if (erro) {
        setObjSnackBar({ type: "error", msg: "Preencha todos os campos" });
        return;
      } else {
        const response = await solicitaDocsPrevias(solicitacao);
        setObjSnackBar({ type: "success", msg: response.mensagem });

        handleCloseModal();
      }
    } catch (error) {
      console.error(error);
      setObjSnackBar({ type: "error", msg: "Erro ao solicitar documentos" });
    } finally {
      setLoading(false);
    }
  };

  const buttonCloseStyle = {
    borderColor: "#18316e",
    color: "#18316e",
    transition: "transform 0.3s ease-in-out",
    "&:hover": { transform: "scale(1.1)", border: "1px solid #18316e" },
  };

  const buttonSubmitStyle = {
    backgroundColor: "#18316e",
    transition: "transform 0.3s ease-in-out",
    "&:hover": { backgroundColor: "#18316e", transform: "scale(1.1)" },
  };

  return (
    <>
      <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>Solicitar documentos</DialogTitle>
        <DialogContent>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <>
              <form className={styles.containerForm} onSubmit={handleSubmit}>
                {optionsDocs.length > 0 ? (
                  <>
                    <Autocomplete
                      multiple
                      fullWidth
                      options={optionsDocs}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Documentos faltantes"
                          error={objectSubmit.documentos.error}
                          value={objectSubmit.documentos.value}
                        />
                      )}
                      onChange={(_, value) => handleChange("documentos", value)}
                    />
                    <TextField
                      error={objectSubmit.observacoes.error}
                      onChange={(e) =>
                        handleChange("observacoes", e.target.value)
                      }
                      value={objectSubmit.observacoes.value}
                      label="Observações"
                      multiline
                      rows={5}
                      fullWidth
                      variant="outlined"
                    />
                  </>
                ) : (
                  "Erro ao buscar documentos"
                )}
                <DialogActions sx={{ width: "100%", padding: "0" }}>
                  <div className={styles.containerButton}>
                    <Button
                      sx={buttonCloseStyle}
                      variant="outlined"
                      color="primary"
                      type="button"
                      onClick={handleCloseModal}
                    >
                      Fechar
                    </Button>

                    <Button
                      sx={buttonSubmitStyle}
                      variant="contained"
                      color="primary"
                      type="submit"
                    >
                      Solicitar
                    </Button>
                  </div>
                </DialogActions>
              </form>
            </>
          )}
        </DialogContent>
      </Dialog>

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default ModalSolicitaDocs;
